import React from 'react'
import PropTypes from 'prop-types'
import { DisplayXPKinshipRelations } from 'components/DueDiligence/Questions'
import { addKeyToObjectsArray } from 'utils/addUniqueKeyToObjects'
import { Expansible } from 'components/Expansible'
import BuildFamilyRelations from 'components/ExpandedInfo/BgcExpansible/BuildFamilyRelations'

import styles from './styles'

function BuildFamilyRelationsReviewInfo(props) {
  const { reviewData } = props

  const classes = styles()

  return (
    <div className={classes.root}>
      <h2>Dados auxiliares para a análise</h2>
      <Expansible title="Respostas do formulário Due Diligence">
        {addKeyToObjectsArray(reviewData?.related_form_answers)?.map(
          (answer) => (
            <DisplayXPKinshipRelations
              key={answer.key}
              questionData={answer?.answer_object}
            />
          ),
        )}
      </Expansible>
      <Expansible title="Dados do Bureau relacionados ao assessor">
        <BuildFamilyRelations
          familyRelationsData={reviewData.family_relation}
        />
      </Expansible>
    </div>
  )
}

BuildFamilyRelationsReviewInfo.propTypes = {
  reviewData: PropTypes.shape({
    created: PropTypes.string,
    updated: PropTypes.string,
    uuid: PropTypes.string,
    decisions: PropTypes.arrayOf(
      PropTypes.shape({
        created: PropTypes.string,
        updated: PropTypes.string,
        uuid: PropTypes.string,
        area_decision: PropTypes.string,
        reviewer_id: PropTypes.number,
        reviewer: PropTypes.shape({
          uuid: PropTypes.string,
          email: PropTypes.string,
          display_name: PropTypes.string,
        }),
        reviewer_comment: PropTypes.string,
        current_review_area: PropTypes.string,
      }),
    ),
    result: PropTypes.string,
    current_review_area: PropTypes.string,
    reason: PropTypes.string,
    related_form_answers: PropTypes.arrayOf(
      PropTypes.shape({
        uuid: PropTypes.string,
        answer_object: PropTypes.object,
      }),
    ),
    extra_questions: PropTypes.arrayOf(
      PropTypes.shape({
        uuid: PropTypes.string,
        text: PropTypes.string,
        occurrence: PropTypes.shape({
          reason: PropTypes.string,
          classification: PropTypes.string,
        }),
        answered: PropTypes.bool,
        subject: PropTypes.string,
      }),
    ),
    type: PropTypes.string,
    family_relation: PropTypes.shape({
      uuid: PropTypes.string,
      has_conflicting_relatives: PropTypes.bool,
      conflicting_relatives: PropTypes.arrayOf(
        PropTypes.shape({
          uuid: PropTypes.string,
          relative_data: PropTypes.shape({
            cpf: PropTypes.string,
            name: PropTypes.string,
            degree: PropTypes.string,
            elector_title_number: PropTypes.string,
            emails: PropTypes.string,
            gender: PropTypes.string,
            pis_number: PropTypes.string,
            procon: PropTypes.string,
            possible_kinship: PropTypes.string,
            rg: PropTypes.string,
            marital_status: PropTypes.string,
            filiation: PropTypes.string,
          }),
          employee_data: PropTypes.shape({
            full_name: PropTypes.string,
            system_user_name: PropTypes.string,
            gender: PropTypes.string,
            company: PropTypes.string,
            company_name: PropTypes.string,
            email: PropTypes.string,
            job_role: PropTypes.string,
            seniority: PropTypes.string,
            organizational_unity: PropTypes.string,
            organizational_unity_code: PropTypes.string,
            center_cost: PropTypes.string,
            center_cost_code: PropTypes.string,
            group: PropTypes.string,
          }),
        }),
      ),
    }),
  }).isRequired,
}

export default BuildFamilyRelationsReviewInfo
